<template>
  <div>
    <div class="toolbar">
      <div class="top-icon device" :class="{'landscape': landscape}">
        <i class="material-icons md-18" @click="setDevice('phone')" :class="{'active': device==='phone'}">phone_iphone</i>
      </div>
      <div class="top-icon device" :class="{'landscape': landscape}">
        <i class="material-icons md-18" @click="setDevice('tablet')" :class="{'active': device==='tablet'}">tablet_mac</i>
      </div>
      <div class="top-icon device no-rotate">
        <i class="material-icons md-18" @click="setDevice('notebook')" :class="{'active': device==='notebook'}">laptop_mac</i>
      </div>
      <div class="top-icon device no-rotate">
        <i class="material-icons md-18" @click="setDevice('desktop')" :class="{'active': device==='desktop'}">desktop_mac</i>
      </div>
      <div class="top-icon device no-rotate">
        <i class="material-icons md-18">more_vert</i>
      </div>
      <div class="top-icon device no-rotate">
        <i class="material-icons md-18" @click="refreshViewer">refresh</i>
      </div>
      <div class="top-icon device no-rotate">
        <i class="material-icons md-18" @click="showStart">close</i>
      </div>
    </div>
    <iframe :src="previewSite" :class="iframeClass" frameborder="0"></iframe>
  </div>
</template>

<script>
  export default {
    name: 'Viewer',
    data() {
      return {
        msg: 'Welcome to Your Vue.js App',
        previewSite: window.location.origin + '/start',
        device: 'desktop',
        landscape: false
      }
    },
    computed: {
      iframeClass: function () {
        return this.device + (this.landscape ? ' landscape' : '');
      }
    },
    mounted() {
      this.previewSite = this.$route.query.v;
    },
    methods: {
      refreshViewer: function () {
        location.reload(true);
      },
      showStart: function () {
        this.previewSite = window.location.origin + '/start';
      },
      setDevice: function (device) {
        if (this.device === device && (device === 'phone' || device === "tablet")) {
          this.landscape = !this.landscape;
        }
        this.device = device;
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Viewer.vue